export default __webpack_public_path__ + "static/services-soc-parallax-643ee97be0568923a45994309d476e6b.jpg";